import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=3987d332&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=3987d332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987d332",
  null
  
)

component.options.__file = "Feedback.vue"
export default component.exports